import {addLoadingClass} from "../../../../default/global/js/utilities/updateClasses";

export function addLoadingClassAfterSubmit(query = document.querySelectorAll('.js-loadingAfterSubmit')) {
    for (let btn of query) {
        btn.addEventListener("click", function () {
            if (btn.form && !btn.form.checkValidity()) {
                return;
            }
            addLoadingClass(btn);
            if (btn.getAttribute("form")) {
                setTimeout(function () {
                    btn.classList.remove("is-loading");
                }, 2000);
            }
        });
    }
}